import { FilePdfOutlined, RollbackOutlined } from '@ant-design/icons'
import { Button, DatePicker, Form, Input, message, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { PostCOA, UploadDocs } from '../../../../API/PostData'
import { AuthData, UpperCaseInput } from '../../../../Components/Global'
import InputModal from '../../../../Components/InputModal'
import { GetAllCOA, GetAllCOASample, GetAllDocument, GetOrders, GetSPCOAOrder } from '../../../../API/GetData'
import HeaderTitle from '../../../../Components/HeaderTitle'
import dayjs from 'dayjs'
import { columnsRFNumber } from './ColumnsCOA'
import UploadFileCOA from './UploadFileCOA'
import { decrypt } from '../../../../Utils/CryptoHelper'
import { UpdateCOA } from '../../../../API/UpdateData'
import { DelUploads } from '../../../../API/DeleteData'
import COASample from './COASample'

const safeDecode = (value) => {
  try {
    return value ? decodeURIComponent(value) : '';
  } catch (e) {
    console.error('Failed to decode URI component:', value);
    return '';
  }
};

const FormCOA = () => {

  const [form] = Form.useForm();
  const navigate = useNavigate();

  const Auth = AuthData();
  const AccountId = Auth && Auth.AccountId;

  const params = useParams();
  const { accountid, code } = params;

  const DecAccountId = decrypt(safeDecode(accountid));
  const DecCode = decrypt(safeDecode(code));
  const [dataEditCOASample, setDataEditCOASample] = useState([]);
  const [dataDocs, setDataDocs] = useState([]);

  const [files, setFiles] = useState(null);

  const [loading, setLoading] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const [COACode, setCOACode] = useState("");
  const [changeStatus, setChangeStatus] = useState(null);

  // const [dataCustomer, setDataCustomer] = useState([]);
  // const [selectCustomer, setSelectCustomer] = useState("");
  // const [openCustomer, setOpenCustomer] = useState(null);

  const [dataRFNumber, setDataRFNumber] = useState([]);
  const [selectRFNumber, setSelectRFNumber] = useState("");
  const [openRFNumber, setOpenRFNumber] = useState(null);
  const OrderCode = selectRFNumber ? selectRFNumber.OrderCode : "";
  const OrderQuotation = selectRFNumber ? selectRFNumber.OrderQuotation : "";
  const RFNumber = selectRFNumber ? selectRFNumber.RFNumber : "";
  const ReportNumber = selectRFNumber ? selectRFNumber.ReportNumber : "";

  const [dataCOASample, setDataCOASample] = useState([]);


  useEffect(() => {
    if (DecAccountId && DecCode) {
      const fethcEditData = async () => {
        try {
          const [resCOA] = await GetAllCOA(DecAccountId, DecCode);
          const resCOAOrder = await GetSPCOAOrder(DecAccountId);
          const filterCOAOrder = resCOAOrder.find((item) => item.RFNumber === resCOA.RFNumber);

          setSelectRFNumber(filterCOAOrder);
          setOpenRFNumber(true);

          const resCOASample = await GetAllCOASample(DecAccountId, DecCode);
          setDataEditCOASample(resCOASample);

          const resDoc = await GetAllDocument(DecAccountId, DecCode);
          setDataDocs(resDoc);

          const payload = {
            ...resCOA,
            COADate: dayjs(resCOA.COADate),
            COASentDate: resCOA.COASentDate ? dayjs(resCOA.COASentDate) : '',
            PublishDate: resCOA.PublishDate ? dayjs(resCOA.PublishDate) : '',
          };

          form.setFieldsValue(payload);

        } catch (error) {
          console.log(error);
        }
      }

      fethcEditData();

    }
  }, [DecAccountId, DecCode, form]);



  useEffect(() => {
    const fetchCOA = async () => {
      try {
        const res = await GetAllCOA();
        const today = new Date();
        // Format tanggal menjadi MMDD (bulan dan hari)
        const month = (today.getMonth() + 1).toString().padStart(2, "0");
        const day = today.getDate().toString().padStart(2, "0");
        const datePrefix = `${month}${day}`;

        if (res.length > 0) {
          // Filter COA dengan prefix COA dan tanggal hari ini
          const todayPrefix = `COA${datePrefix}`;
          const filteredData = res.filter(item => item.COACode.startsWith(todayPrefix));

          if (filteredData.length > 0) {
            // Ambil nomor terakhir dan tambahkan 1
            const lastCOA = filteredData[filteredData.length - 1].COACode;
            const lastNumber = parseInt(lastCOA.substring(7)); // 7 karakter: COA + MMDD
            const nextNumber = lastNumber + 1;
            const nextNo = `COA${datePrefix}${nextNumber.toString().padStart(3, "0")}`;
            setCOACode(nextNo);
          } else {
            setCOACode(`COA${datePrefix}001`);
          }
        } else {
          setCOACode(`COA${datePrefix}001`);
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchCOA();
  }, []);


  useEffect(() => {
    if (form && COACode && !DecAccountId && !DecCode) {
      form.setFieldsValue({
        COACode: COACode,
        COADate: dayjs(),
        Status: 'Process'
      })
    }
  }, [COACode, DecAccountId, DecCode, form]);


  // // Customer
  // useEffect(() => {
  //   const fetchCustomer = async () => {
  //     try {
  //       const res = await GetCustomers();
  //       setDataCustomer(res);

  //     } catch (error) {
  //       console.log(error);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   }
  //   if (openCustomer && !DecAccountId && !DecCode) {
  //     fetchCustomer();
  //     setOpenCustomer(false);
  //     setSelectOrder("");
  //     setDataOrder([]);
  //   }
  // }, [DecAccountId, DecCode, dataEdit, openCustomer]);

  useEffect(() => {
    const fetchRFNumber = async () => {
      try {
        const res = await GetSPCOAOrder(AccountId);
        const filter = res.filter(item =>
          // item.CustomerId === selectCustomer.CustomerId &&
          item.IsStatus
        );
        setDataRFNumber(filter);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }

    if (openRFNumber || (!DecAccountId && !DecCode)) {
      fetchRFNumber();
      setOpenRFNumber(false);
    }

  }, [AccountId, DecAccountId, DecCode, openRFNumber]);


  useEffect(() => {
    if (form && (selectRFNumber)) {
      form.setFieldsValue({
        OrderQuotation: OrderQuotation,
        RFNumber: RFNumber,
        ReportNumber: ReportNumber
      })
    }
  }, [OrderQuotation, RFNumber, ReportNumber, form, selectRFNumber]);


  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const payload = {
        ...values,
        AccountId: Auth?.AccountId,
        OrderCode: OrderCode,
        COASample: dataCOASample,
      };

      // console.log('Submit', payload);

      if (files && files.length > 0) {

        if (DecAccountId && DecCode) {
          const DelDocs = await DelUploads(payload.AccountId, payload.COACode, "REPORT");
          if (DelDocs?.status !== 200) {
            throw new Error('Gagal menghapus file sebelumnya');
          }
          // console.log(DelDocs);
        }

        for (const file of files) {
          const fileObj = file.originFileObj;
          const fileName = file.name;

          const filePayload = new FormData();
          filePayload.append('AccountId', Auth.AccountId);
          filePayload.append('RefNo', payload.COACode);
          filePayload.append('FileName', 'COA');
          filePayload.append('DocType', 'REPORT');
          filePayload.append('fileUploads', fileObj, fileName);

          const fileResponse = await UploadDocs(filePayload);

          if (fileResponse?.status !== 200) {
            throw new Error(`Gagal mengunggah file: ${fileName}`);
          }

          // console.log(`File ${fileName} berhasil diunggah.`);
        }
      }


      let COARes = null;
      if (!DecAccountId && !DecCode) {
        COARes = await PostCOA(payload);

        if (COARes?.status !== 201) {
          throw new Error('Gagal mengirim data COA');
        }
      } else {
        COARes = await UpdateCOA(DecAccountId, DecCode, payload);

        if (COARes?.status !== 200) {
          throw new Error('Gagal mengirim data COA');
        }
      }
      message.success(COARes.data.message);
      navigate('/dashboard/menuorder/coa');

    } catch (error) {
      console.error('Error saat submit:', error);
      message.error(error.message || 'Terjadi kesalahan saat mengirim data');
    } finally {
      setLoading(false);
    }
  };


  const handleReset = async () => {
    form.resetFields();
  }

  return (
    <>
      <div className="flex justify-between items-center">
        <HeaderTitle title="COA" subtitle="Form a COA" />
        <Button icon={<RollbackOutlined />} onClick={() => navigate(-1)}>Back</Button>
      </div>

      <div className="bg-white p-4 rounded-md mt-4">
        <Form
          name="formOrder"
          layout="vertical"
          onFinish={handleSubmit}
          autoComplete="off"
          form={form}
        >

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">

            <Form.Item
              label="COA Code"
              name="COACode"
              rules={[
                {
                  required: true,
                  message: 'Please input your COA Code!',
                },
              ]}
            >
              <Input placeholder="COA Code" disabled />
            </Form.Item>


            <Form.Item
              label="COA Date"
              name="COADate"
              rules={[
                {
                  required: true,
                  message: 'Please input your COA Date!',
                },
              ]}
            >
              <DatePicker className="w-full" placeholder="COA Date" />
            </Form.Item>

            <InputModal
              title="RF Number"
              label="RF Number"
              name="RFNumber"
              dataSource={dataRFNumber}
              loading={isLoading}
              columns={columnsRFNumber}
              onData={(values) => setSelectRFNumber(values)}
              onOpenModal={(values) => setOpenRFNumber(values)}
            />

            <Form.Item
              label="Order Quotation"
              name="OrderQuotation"
              rules={[
                {
                  required: true,
                  message: 'Please input your Order Quotation!',
                },
              ]}
            >
              <Input placeholder="Order Quotation" disabled />
            </Form.Item>

            <Form.Item
              label="Report Number"
              name="ReportNumber"
              rules={[
                {
                  required: true,
                  message: 'Please input your Report Number!',
                },
              ]}
            >
              <UpperCaseInput placeholder="Report Number" />
            </Form.Item>

            <Form.Item
              label="Status"
              name="Status"
              rules={[
                {
                  required: true,
                  message: 'Please input your Status!',
                },
              ]}
            >
              <Select
                allowClear
                placeholder="Select Status"
                onChange={(values) => setChangeStatus(values)}
                options={[
                  {
                    value: 'Process',
                    label: 'Process',
                  },
                  {
                    value: 'Published',
                    label: 'Published',
                  },
                  {
                    value: 'Cancel',
                    label: 'Cancel',
                  },
                ]}
              />
            </Form.Item>

            <Form.Item
              label="Publish Date"
              name="PublishDate"
              rules={
                changeStatus === "Published"
                  ? [
                    {
                      required: true,
                      message: "Please input your Publish Date!",
                    },
                  ]
                  : []
              }
            >
              <DatePicker className="w-full" placeholder="Publish Date" />
            </Form.Item>

            <Form.Item
              label="COA Sent Date"
              name="COASentDate"
            // rules={
            //   changeStatus === "Published"
            //     ? [
            //       {
            //         required: true,
            //         message: "Please input your Publish Date!",
            //       },
            //     ]
            //     : []
            // }
            >
              <DatePicker className="w-full" placeholder="COA Sent Date" />
            </Form.Item>


            <Form.Item
              label="Files"
              name="Files"
              className="md:col-span-2"
            >
              <UploadFileCOA onFiles={(values) => setFiles(values)} />
            </Form.Item>

          </div>

          {DecAccountId && DecCode && (
            <div className="mb-4">
              {dataDocs.map((item, index) => {
                const fileName = item.PathName.split("_").slice(1).join("_");
                return (
                  <div key={index} className="flex items-center gap-2 mb-2">
                    <Link to={`${process.env.REACT_APP_BASEURL}/${item.PathName}`} target="_blank" className="text-blue-500 hover:underline">
                      <FilePdfOutlined /> {fileName}
                    </Link>
                  </div>
                )
              })}
            </div>
          )}

          <div className="border pt-4 rounded-md">
            <COASample
              onSaveData={(values) => setDataCOASample(values)}
              onEditData={dataEditCOASample}
              RFNumber={RFNumber}
            />
          </div>

          <div className="flex justify-end gap-2 mt-4">
            <Button type="primary" htmlType="submit" loading={loading}>Submit</Button>
            <Button htmlType="button" onClick={handleReset}>Reset</Button>
          </div>

        </Form >
      </div >
    </>
  )
}

export default FormCOA;